import memoizeOne from 'memoize-one';
import _isEqual from 'lodash.isequal';

function getContext({
  state: { invoices, showInvoicesModal },
  actions: { openInvoices, closeModal }
}) {
  return {
    state: {
      invoices,
      showInvoicesModal
    },
    actions: {
      openInvoices,
      closeModal
    }
  };
}

function contextIsEqual(newState: any, oldState: any) {
  return _isEqual(getContext(newState[0]), getContext(oldState[0]));
}

export default memoizeOne(getContext, contextIsEqual);
